// Page-only JS for users/givsum3/_profile_public_v3 -- not bundled into the global
// givsum3.js. Registers onto the one running Stimulus Application (window.Stimulus).
import ActivityFeedController from '../../controllers/pages/user_profile/activity_feed_controller'
import FollowButtonController from '../../controllers/pages/user_profile/follow_button_controller'

if (window.Stimulus) {
  window.Stimulus.register('user-profile--activity-feed', ActivityFeedController)
  window.Stimulus.register('user-profile--follow-button', FollowButtonController)
}
